import React from 'react'
import styles from "./Modal.module.scss"
import HTMLContent from "../../../../partials/HTMLContent"

const Modal = (props) => {

    const { show, size, header, children, className, onClose, html } = props

    return (
        <>
        { show && 
            <div className={`${styles.Modal} ${className}`} >
                <div className={`${styles.modal_container} ${size ? styles[size] : ''}`}>
                    <div className={styles.modal_content}>
                        { onClose && <span className={styles.modal_close} onClick={onClose}>x</span> }
                        { header && <h2>{header}</h2>}
                        { html && <HTMLContent html={html} /> }
                        { children || <></> }
                    </div>
                </div>
            </div>
        }
        </>
    )

}

export default Modal;
